export default __webpack_public_path__ + "static/media/heart-fillBlue.f956b653.svg";